const bsx = {
  FORMS: [
    {
      type: 'bsx-contact-form',
      name: 'BsxContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '664270d0b5ff6ae62980a14f',
    name: 'bsx',
    avatar: {
      name: 'BSX',
      header: 'https://chatbotqa.gatblac.com/static/avatar/bsx/bcs.svg',
      new: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      open: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      close: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#0cbda3',
        borderColor: '#0cbda3'
      }
    }
  }
}

export default bsx
